import { IContractProperty } from '../Contract/Contract-types';
import { ISummaryProperty } from '../SummaryPane/SummaryPane-types';

export const isSummaryProperty = (
    property: IContractProperty | ISummaryProperty
): property is ISummaryProperty =>
    (property as ISummaryProperty).autodetectedValueDisplayText !== undefined;
